export const steps = ['gettingStarted', 'generalInformation', 'selectVehicle', 'vehicleUsage'];
